import client from "./client";
import { ensureHostKey } from "./hostApi";

export const getSong = (songId) => client.get(`/Song/GetSong/${songId}`).then((r) => r.data);

const rawSong = ({ title, artist, key, capo, lyrics, public: isPublic }) => ({
  Title: title,
  Artist: artist || null,
  Key: key || null,
  Capo: capo ? Number(capo) : null,
  Lyrics: lyrics,
  Public: Boolean(isPublic),
});

/**
 * Adds a song from plain text (title + lyrics with optional chord lines / [Verse] headers).
 * Host only; the song belongs to this device's host identity, which is registered first if needed.
 */
export const addGuitarSong = async (song) => {
  await ensureHostKey();
  return client.post("/Song/AddGuitarSong", rawSong(song)).then((r) => r.data);
};

/** Replaces a song from plain text. The owner (or a publisher for public songs). */
export const updateGuitarSong = async (songId, song) => {
  await ensureHostKey();
  return client.put(`/Song/UpdateGuitarSong/${songId}`, rawSong(song)).then((r) => r.data);
};

/** Deletes a song and every reference to it. Host only. */
export const deleteSong = (songId) => client.delete(`/Song/DeleteSong/${songId}`, { retry: true });

export const reportIssue = ({ songId, songTitle, issueTypes, description }) =>
  client.post("/Song/ReportIssue", {
    SongId: songId,
    SongTitle: songTitle,
    IssueTypes: issueTypes,
    Description: description,
  });

/** Open issue reports, newest first. Host only. */
export const getIssues = () => client.get("/Song/Issues").then((r) => r.data);

/** Marks an issue report as dealt with. Host only. */
export const resolveIssue = (issueId) => client.put(`/Song/ResolveIssue/${issueId}`, null, { retry: true });

/**
 * Fetches a web page and has the server's AI model extract the song on it into the app's
 * format. Nothing is stored; the host reviews the draft first. Host only, slow.
 */
export const importFromUrl = (url) =>
  client.post("/Song/ImportFromUrl", { Url: url }, { timeout: 120000 }).then((r) => r.data);
